<div>
  <p class="title">
    {{ title }}
  </p>
  <div class="buttons">
    <button mat-raised-button class="primary-btn rounded" mat-dialog-close>Aceptar</button>
  </div>
</div>
